"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseResponse = exports.splitName = exports.sanitizeObject = exports.sanitizeArray = exports.sanitizeString = exports.receiveEmbedData = void 0;
var types_1 = require("./types");
var typeAdapters_1 = require("./typeAdapters");
function receiveEmbedData() {
    var handler;
    return new Promise(function (resolve, reject) {
        if (!window.parent) {
            reject('Cannot receive data without parent');
        }
        handler = function (evt) {
            var data;
            try {
                data = JSON.parse(evt.data);
            }
            catch (error) {
                return;
            }
            if (data.embedData) {
                resolve(data.embedData);
            }
        };
        window.addEventListener('message', handler);
    }).then(function (data) {
        window.removeEventListener('message', handler);
        return data;
    });
}
exports.receiveEmbedData = receiveEmbedData;
function sanitizeString(value) {
    if (!value) {
        return value;
    }
    var tmp = document.createElement('div');
    tmp.innerHTML = value;
    var scripts = Array.from(tmp.getElementsByTagName('script'));
    for (var _i = 0, scripts_1 = scripts; _i < scripts_1.length; _i++) {
        var script = scripts_1[_i];
        if (script.parentNode) {
            script.parentNode.removeChild(script);
        }
    }
    return tmp.innerHTML;
}
exports.sanitizeString = sanitizeString;
function sanitizeArray(array) {
    return array.map(sanitizeObject);
}
exports.sanitizeArray = sanitizeArray;
function sanitizeObject(object) {
    if (object === null || object === undefined) {
        return object;
    }
    else if (Array.isArray(object)) {
        return sanitizeArray(object);
    }
    else if (typeof object === 'string') {
        return sanitizeString(object);
    }
    else if (typeof object === 'object') {
        var newObject = {};
        for (var _i = 0, _a = Object.entries(object); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (Array.isArray(value)) {
                newObject[key] = sanitizeArray(value);
            }
            else if (typeof value === 'string') {
                newObject[key] = sanitizeString(value);
            }
            else {
                newObject[key] = sanitizeObject(value);
            }
        }
        return newObject;
    }
    else {
        return object;
    }
}
exports.sanitizeObject = sanitizeObject;
function splitName(fullname) {
    var nameParts = fullname.split(' ');
    var firstName = nameParts.slice(0, -1).join(' ') || 'NOT GIVEN';
    var lastName = nameParts.slice(-1).join(' ');
    var nameObj = {
        firstName: firstName,
        lastName: lastName,
    };
    return nameObj;
}
exports.splitName = splitName;
function parseResponse(response, opts) {
    return response.json().then(function (json) {
        var errors = [];
        if (response.status !== 200) {
            if (json.result !== undefined) {
                Object.keys(json.result).forEach(function (key) {
                    errors.push(new types_1.ClientError(json.result[key].join(' \n'), {
                        field: key,
                    }));
                });
            }
            if (json.messages !== undefined) {
                json.messages.forEach(function (msg) {
                    if (msg.category === 'error') {
                        errors.push(new types_1.ClientError(msg.message));
                    }
                });
            }
            else {
                errors.push(new types_1.ClientError(json.message));
            }
        }
        if (opts && opts.throwErrors && errors.length) {
            throw typeAdapters_1.collapseClientErrors(errors);
        }
        return {
            errors: errors,
            _raw_response: json,
        };
    });
}
exports.parseResponse = parseResponse;
